import axios from "axios";
import Config from "config";

const login = ({ email, password }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/login`, {
        email,
        password,
      })
      .then((res) => res.data)
      .then((loginResponse) => resolve(loginResponse))
      .catch((error) => console.log(error));
  });
};

const resetPassword = ({ email }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/password-reset`, {
        email,
      })
      .then((res) => res.data)
      .then((passwordResetResponse) => resolve(passwordResetResponse))
      .catch((error) => console.log(error));
  });
};

const register = ({
  name,
  logo,
  email,
  password,
  type,
  location,
  companySize,
  website,
}) => {
  return new Promise((resolve, reject) => {
    const data = new FormData();
    data.append("name", name);
    data.append("logo", logo);
    data.append("email", email);
    data.append("password", password);
    data.append("type", type);
    data.append("location", location);
    data.append("companySize", companySize);
    data.append("website", website);

    axios
      .post(`${Config.baseURL}/register`, data)
      .then((res) => res.data)
      .then((registerResponse) => resolve(registerResponse))
      .catch((error) => console.log(error));
  });
};

export default { login, register, resetPassword };
